export default "__VITE_ASSET__BxykZqbk__"